(function($){
      
$('.close-bar').click(function(){
  $(this).parents('.announcement_bar').slideUp(300);
});

$('.icon-cart').click(function(){
    $('.side_cart').addClass('active');
})

$('.side-cart-close').click(function(){
    $('.side_cart').removeClass('active');
})

$('.m-filter').click(function(){
    $('.choose_category').toggleClass('active', 500);
    $(this).toggleClass('active', 500)
})

// $('.acc-setting a').click(function(){
//     $('.account-list').toggle(500);
// })

$('body').on("click", ".acc-setting a", function(){
 $('.account-list').toggle(500);

});

$('.header__nav-button').click(function(){
    $(this).toggleClass('active', 500);
    $('#mobile-menu').toggleClass('open', 500)
})

$('.btn-next').click(function(){
    $(this).next('.MegaMenu').addClass('active-slide', 500)
})

$('.back-btn').click(function(){
    $('.MegaMenu').removeClass('active-slide', 500)
})

$(document).on("scroll", function(){
  if($(document).scrollTop() > 70 ){
    $("body:not(#sizzle) #header").addClass("shrink");
  }
  else
  {
    $("body:not(#sizzle) #header").removeClass("shrink");
  }
});

$(document).ready(function(){
  $('#charcount').keyup(function () {
    var max = 200;
    var len = $(this).val().length;
    if (len >= max) {
      $('#charNum').text(' you have reached the limit');
    } else {
      var char = max - len;
      $('#charNum').text(char + ' Character Remaining');
    }
  });
});
  
        $(window).on('load', function() {
      var now, lastDatePopupShowed;
      now = new Date();

      if (localStorage.getItem('lastDatePopupShowed') !== null) {
        lastDatePopupShowed = new Date(parseInt(localStorage.getItem('lastDatePopupShowed')));
      }

      if (((now - lastDatePopupShowed) >= (15 * 86400000)) || !lastDatePopupShowed) {
        var delay = $('#agepopup').attr("data-delay");
    
       
      
      	localStorage.setItem('lastDatePopupShowed', now);
         
     
        
      }
         
		  
    });


  $('.c-blog-img a').each(function(){
      $(this).find('img').hide();
      var _Bg = 'url('+ $(this).find('img').attr('src') + ')';
      $(this).css("background-image", _Bg);
      $(this).find('img').hide();
    }); 

  
  
  $('.close-join').click(function(){
    $('.join_wrap').removeClass('active'); 
  })
  

//   $(document).ready(function() {
//     $("#accordion .ingre.collapsed").click(function(event){
//         $('html, body').animate({scrollTop: '-=350px'}, 800);
//     });
// });
$(document).ready(function (){
            $("#accordion .ingre.collapsed").click(function (){
                $('html, body').animate({
                    scrollTop: $("#accordion").offset().top - 200
                }, 2000);
            });
        });
  
// $('.article_banner').each(function(){
//       $(this).find('img').hide();
//       var _Bg = 'url('+ $(this).find('img').attr('src') + ')';
//       $(this).css("background-image", _Bg);
//       $(this).find('img').hide();
//     }); 
    
$('.brand-logo').owlCarousel({
  loop:true,
  margin:15,
  nav:false,
  autoplay:true,
  autoplayTimeout:2000,
  autoplayHoverPause:true,
 responsive:{ 
      0:{
          items:3,
          stagePadding: 0,
        nav:true,
          margin:15
      },
      640:{
          items:3,
          stagePadding: 0,
          nav:true,
          margin:15
      },
      992:{
          items:6,
          stagePadding: 45,
          margin:15
      },
      1000:{
          items:8,
          margin:15
      }
  }
})

$('.doze_slide').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    responsive:{ 
        0:{
            items:1,
            margin:0
        },
        640:{
            items:2,
            margin:15
        },
        992:{
            items:2
        },
        1200:{
            items:3
        }
    }
});
  
  $('.recover_like_row').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
    responsive:{ 
        0:{
            items:1,
          nav:true,
            margin:0
        },
        640:{
            items:2,
           nav:true,
            margin:0
        },
        992:{
            items:2,
            nav:true,
        },
        1200:{
            items:3
        }
    }
});

  $('.collection_slide_wrap').owlCarousel({
    stagePadding: 75,
    loop:true,
    rewind:true,
    margin:0,
    nav:true,
   responsive:{ 
        0:{
            items:1,
            stagePadding: 20,
            margin:0
        },
        640:{
            items:1,
            stagePadding: 150,
            margin:0
        },
        992:{
            items:2
        },
        1200:{
            items:3
        }
    }
})
  
  $('.collection_slide_wraps').owlCarousel({
    stagePadding: 75,
    loop:false,
    rewind:true,
    margin:0,
    nav:true,
   responsive:{ 
        0:{
            items:1,
            stagePadding: 20,
            margin:0
        },
        640:{
            items:1,
            stagePadding: 150,
            margin:0
        },
        992:{
            items:2
        },
        1200:{
            items:3
        }
    }
})
  
  $(window).load(function(){
    $('.collection_slide_wraps').find('.owl-next').trigger('click');
    });


$('.review_slide').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
   responsive:{ 
        0:{
            items:1,
            stagePadding: 29,
            margin:0
        },
        640:{
            items:2,
            margin:8
        },
        992:{
            items:2
        },
        1200:{
            items:3
        }
    }
})




$('.marquee__item_slide').slick({
  slidesToShow: 1,
  infinite:true,
  slidesToScroll: 1,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 70000,
  arrows:false,
//   pauseOnHover: true,
  cssEase: 'linear'
});
  

$('.s-down').on('click', function(e) {
				
				e.preventDefault(); // prevent hard jump, the default behavior
				var target = $(this).attr("href"); // Set the target as variable
				console.log(target);
		
				$('html, body').stop().animate({
						scrollTop: $(target).offset().top - 50
				}, 600, function() {
						//location.hash = target; //attach the hash (#jumptarget) to the pageurl
						console.log($(target).offset().top);
				});

				return false;				
		});	
  


  function scaleToFill() {
    $('video.video-background').each(function(index, videoTag) {
       var $video = $(videoTag),
           videoRatio = videoTag.videoWidth / videoTag.videoHeight,
           tagRatio = $video.width() / $video.height(),
           val;
        
       if (videoRatio < tagRatio) {
           val = tagRatio / videoRatio * 1.02; // size increased by 2% because value is not fine enough and sometimes leaves a couple of white pixels at the edges
       } else if (tagRatio < videoRatio) {
           val = videoRatio / tagRatio * 1.02;
       }
       
       $video.css('transform','scale(' + val  + ',' + val + ')');
        $('video.video-background').show();
    });    
}

$(function () {
    scaleToFill();
    $('.video-background').on('loadeddata', scaleToFill);
    
    $(window).resize(function() {
        scaleToFill();
       
    });
});

  

function containerWidth() {
    
    var Width = $(".footer_wrap .container").outerWidth();
    var winwidth = $(window).width();
    var Diff = (winwidth-Width)/2;

    $('.featured_text').css('padding-left', Diff +'px');
    $('.member-banner-text').css('padding-left', Diff +'px');
    $('.collection_banner_text').css('padding-left', Diff +'px');

  }
  
 

 $(document).ready(function(){
   setTimeout(function(){ 
    $('.join_wrap').addClass('active'); 
}, 3000);
  containerWidth();
}); 
 $(window).resize(function(){
  containerWidth();
}); 

$('#subs').click(function(){
 $('.purchase_text').hide();
 $('.sub_text').show();
});
$('#purch').click(function(){
    $('.purchase_text').show();
    $('.sub_text').hide();
   });
   //$('.back-sub').click(function(){
//      $('#subs').trigger();
//     $('.purchase_text').show();
//     $('.sub_text').hide();
//   });
  
  
  $('body').on("click", ".back-sub", function(){
  $('#subs').trigger( "click" );
  
    $('.purchase_text').hide();
    $.parrents('.sub_text').show();

});
  
// $(document).ready(function(){
//        $('.sub-btn').bind("click", jump);
//        return false;
// });

$(".u-qty .QuantitySelector__Button").on("click", function() {

    var $button = $(this);
    var oldValue = $button.parent('.u-qty').find("input").val();

    if ($button.hasClass('u-plus')) {
        var newVal = parseFloat(oldValue) + 1;
    } else {
        // Don't allow decrementing below zero
        if (oldValue > 1) {
            var newVal = parseFloat(oldValue) - 1;
        } else {
            newVal = 1;
        }
    }

    $button.parent().find("input").val(newVal);

});

var pos = $('.member_box').offset().top+300; 
pos = pos+300;
$(window).scroll(function(){
if($('html').scrollTop()>pos) {
  $('.sticky-btn').addClass('fixed');
}
else {
  $('.sticky-btn').removeClass('fixed');
}

});
  
  

  
 



// $('ul.accordion').accordion();





})(jQuery);


